import { useDispatch, useSelector } from "react-redux";
import { downloadTradesReport } from "../thunks/downloadTradesReport";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useTradesReportDownloader = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.reports.exchbusiness.clientOverview.fetchState
	);
	const dispatch = useDispatch();
	const download = React.useCallback(() => dispatch(downloadTradesReport()), [dispatch]);

	return [download, fetchState] as [typeof download, typeof fetchState]
};
